import { CustomRegexpValidationItem, StringValidation } from '@rehau/shared/forms/validations';

export class CustomRegexpValidation extends StringValidation {
  constructor(items: CustomRegexpValidationItem[]) {
    super(null, null, items);
  }
}
